import { Box, Button } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";
import ChevronRight from "@mui/icons-material/ChevronRight";

/**
 * Shared "View …" action button rendered beneath a map popup's HTML content.
 * Supports either a router link (`to`) or a click handler (`onClick`).
 *
 * @param {Object} props
 * @param {string} props.label - Button label
 * @param {string} [props.to] - Router path; renders the button as a RouterLink
 * @param {Function} [props.onClick] - Click handler (used when `to` is omitted)
 */
const MapPopupActionButton = ({ label, to, onClick }) => {
  const theme = useTheme();

  const linkProps = to ? { component: RouterLink, to } : { onClick };

  return (
    <Box sx={{ mt: 1.5, px: 1.5 }}>
      <Button
        {...linkProps}
        variant="outlined"
        size="small"
        fullWidth
        endIcon={<ChevronRight />}
        sx={{
          borderRadius: 1.5,
          textTransform: "none",
          fontWeight: 600,
          borderColor: alpha(theme.palette.primary.main, 0.5),
          color: theme.palette.primary.main,
          backgroundColor:
            theme.palette.mode === "dark"
              ? alpha(theme.palette.primary.main, 0.16)
              : "transparent",
          "&:hover": {
            borderColor: theme.palette.primary.main,
            backgroundColor: alpha(
              theme.palette.primary.main,
              theme.palette.mode === "dark" ? 0.25 : 0.12
            ),
          },
        }}
      >
        {label}
      </Button>
    </Box>
  );
};

export default MapPopupActionButton;
